import React, { useEffect, useRef, useState } from "react";
import PostImage from "./PostImage";
import axios from "../../../../../axios";
import { toast } from "react-toastify";

function SinglePostImage({
  isPostCreated,
  communityId,
  setIsPostCreated,
  community,
  reRenderPage,
}) {
  const [postList, setPostList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const [members, setMembers] = useState([]);
  const teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [filter, setFilter] = useState({
    limit: 20,
    page: 1,
    sortBy: -1,
  });
  const loadingRef = useRef(false);
  const lastPageRef = useRef(false);

  const { limit, page, sortBy } = filter;

  // const handelInfiniteScroll = async () => {
  //   try {
  //     if (
  //       document.getElementById("single-post-image-scroll").clientHeight +
  //       document.getElementById("single-post-image-scroll").scrollTop +
  //       1 >=
  //       document.getElementById("single-post-image-scroll").scrollHeight
  //     ) {
  //       setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
  //       setIsPostCreated(false)
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("single-post-image-scroll").clientHeight +
          document.getElementById("single-post-image-scroll").scrollTop +
          1.9 >=
        document.getElementById("single-post-image-scroll").scrollHeight
      ) {
        if (!loadingRef.current && !lastPageRef.current) {
          setFilter((prevState) => ({
            ...prevState,
            page: prevState.page + 1,
          }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const element = document.getElementById("single-post-image-scroll");
    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page]);

  const getPostsRefetch = async () => {
    setPostList([]);
    try {
      const post = await axios.get(
        `/api/v1/community/post/getByCommunityId/${communityId}?_page=${page}&_limit=${limit}&sortBy=${sortBy}`
      );
      post && setPostList(post.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getPosts = async () => {
    try {
      if (isLastPage) {
        setIsLoading(false);
        return false;
      }

      setIsLoading(true);
      loadingRef.current = true;
      const res = await axios.get(
        `/api/v1/community/post/getByCommunityId/${communityId}?_page=${page}&_limit=${limit}&sortBy=${sortBy}`
      );

      // post && setPostList((prevData) => [...prevData, ...post.data.data]);
      loadingRef.current = false;
      const totalFetchedPosts = postList.length + res.data.data.length;
      const loadedQuery = Math.min(
        totalFetchedPosts,
        res.data.total_post_count
      );
      if (
        res.data.data.length == 0 ||
        loadedQuery === res.data.total_post_count
      ) {
        lastPageRef.current = true;
      }
      if (page === 1) {
        setPostList(res.data.data);
      } else {
        setPostList((prev) => [...prev, ...res.data.data]);
      }
      if (res.data.data.length > 0) {
        toast.info(
          `Loading Post (${loadedQuery + "/" + res.data.total_post_count})`,
          {
            position: "bottom-center",
          }
        );
      } else {
        toast.info(
          `Loaded Post (${loadedQuery + "/" + res.data.total_post_count})`,
          {
            position: "bottom-center",
          }
        );
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // if (isPostCreated) {
    //   setPostList([]);
    // }

    getPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, isPostCreated, sortBy, reRenderPage]);

  useEffect(() => {
    const getMembers = async () => {
      try {
        const res = await axios.get(
          `/api/v1/community/${community.id}/getMember`
        );
        setMembers(res.data.data.members);
      } catch (error) {
        if (error.response) {
          console.error(
            "API Error:",
            error.response.data.message || error.message
          );
        } else {
          // Other errors
          // console.error("Error:", error.message);
        }
      }
    };
    getMembers();
  }, []);

  const isAdminOrTeacherAdmin = members.some((member) => {
    if (member.admins_id) {
      return member.admins_id.some((admin) => admin.admin.id === teacher_id);
    } else if (member.teachers_id) {
      return member.teachers_id.some(
        (teacher) =>
          teacher.teacher.id === teacher_id && teacher.role === "moderator"
      );
    }
    return false;
  });
  console.log("postList", postList);

  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center">
          <img
            className="request_post_loader"
            src="/gif/LoaderDot.gif"
            alt="Loading..."
          />
        </div>
      ) : postList.length > 0 ? (
        postList.map((post) => (
          <PostImage
            key={post.id}
            post={post}
            community={community}
            isAdminOrTeacherAdmin={isAdminOrTeacherAdmin}
            refetch={getPostsRefetch}
            members={members}
            setIsPostCreated1={setIsPostCreated}
          />
        ))
      ) : (
        <div className="view_no_post_msg mt-3">
          No posts yet. Be the first one to add a post to community.
        </div>
      )}
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <img
            className="request_post_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      )}
    </div>
  );
}

export default SinglePostImage;
